module.exports = __webpack_public_path__ + "static/img/antek_logo_white.aef900c.png";